import isEmpty from 'lodash/isEmpty'

export const isPreviousChatSession = () => {
  const rawData = localStorage.getItem(`${process.env.REACT_APP_MIAW_ORGID}_WEB_STORAGE`) || '{}'
  try {
    const result = JSON.parse(rawData)
    return !isEmpty(result)
  } catch (err) {
    return false
  }
}

export const deletePreviousChatSession = () => {
  const rawData = localStorage.getItem(`${process.env.REACT_APP_MIAW_ORGID}_WEB_STORAGE`)
  if (rawData) {
    try {
      const result = JSON.parse(rawData)
      if (!isEmpty(result)) {
        localStorage.removeItem(`${process.env.REACT_APP_MIAW_ORGID}_WEB_STORAGE`)
      }
    } catch (err) {
      console.error('Error parsing previous MIAW session data:', err)
    }
  }
}
